import { Box, Divider, Typography } from "@mui/material";
import { AccountReportContent } from "./account-report-content";
import {
  ReplyDataProps,
  ReportContainerPropsType,
} from "../../interface/account";
import { useNavigate } from "react-router-dom";
import { PATH_DASHBOARD } from "../../routes/path";
import AccountComment from "./account-reply";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  apiGetAccountBookmark,
  apiGetAccountPetitions,
  apiGetAccountPosts,
  apiGetAccountReplies,
  apiGetRepSignedPetitions,
  apiGetRepTaggedPetitions,
} from "../../api/account";

import {
  SkeletonAccountPostLoading,
  SkeletonAccountReplyLoading,
} from "../ui-elements/skeleton-loading";
import useInfiniteScrollFetcher from "../../hooks/useInfiniteScrollFetcher";
import { PostContentDetails } from "../../interface/posts";
import ReportContainer from "../report-container";

export const AccountPetition = () => {
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const { items, sentryRef, loading } =
    useInfiniteScrollFetcher<ReportContainerPropsType>({
      fetchData: apiGetAccountPetitions,
      initialParams: { page: 1, page_size: 10, account_id: account_profile.id },
    });

  return (
    <Box>
      {items?.map((feed: ReportContainerPropsType, index: number) => (
        <Box key={index}>
          <ReportContainer
            key={index}
            id={feed?.id}
            link={feed?.id}
            content={feed?.context}
            account={feed?.author}
            title={feed?.title}
            source={feed?.post_type}
            badge={feed?.author_badge ?? 0}
            avatarImg={feed?.author_photo_url ?? ""}
            date={feed?.created_at}
            image={feed?.media}
            current_user_bookmarked={feed?.current_user_bookmarked ?? false}
            current_user_liked={feed?.current_user_liked ?? false}
            current_user_reposted={feed?.current_user_reposted ?? false}
            data={feed}
            social={{
              message: feed?.comments,
              repost: feed?.reposts,
              like: feed?.likes,
            }}
          />
          <Divider sx={{ my: 3 }} />
        </Box>
      ))}
      <div ref={sentryRef} style={{ width: "560px", margin: "0 auto" }}>
        {loading && (
          <Box sx={{}}>
            <SkeletonAccountPostLoading />
          </Box>
        )}
      </div>
      {!loading && items?.length === 0 && (
        <Box
          sx={{
            width: "80%",
            mx: "auto",
            height: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            No Petition has been created.
          </Typography>
        </Box>
      )}
    </Box>
  );
};
export const AccountSignedPetition = () => {
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const { items, sentryRef, loading } =
    useInfiniteScrollFetcher<ReportContainerPropsType>({
      fetchData: apiGetRepSignedPetitions,
      initialParams: { page: 1, page_size: 10, account_id: account_profile.id },
    });

  return (
    <Box>
      {items?.map((feed: ReportContainerPropsType, index: number) => (
        <Box key={index}>
          <ReportContainer
            key={index}
            id={feed?.id}
            link={feed?.id}
            content={feed?.context}
            account={feed?.author}
            title={feed?.title}
            source={feed?.post_type}
            badge={feed?.author_badge ?? 0}
            avatarImg={feed?.author_photo_url ?? ""}
            date={feed?.created_at}
            image={feed?.media}
            current_user_bookmarked={feed?.current_user_bookmarked ?? false}
            current_user_liked={feed?.current_user_liked ?? false}
            current_user_reposted={feed?.current_user_reposted ?? false}
            data={feed}
            social={{
              message: feed?.comments,
              repost: feed?.reposts,
              like: feed?.likes,
            }}
          />
          <Divider sx={{ my: 3 }} />
        </Box>
      ))}
      <div ref={sentryRef} style={{ width: "560px", margin: "0 auto" }}>
        {loading && (
          <Box sx={{}}>
            <SkeletonAccountPostLoading />
          </Box>
        )}
      </div>
      {!loading && items?.length === 0 && (
        <Box
          sx={{
            width: "80%",
            mx: "auto",
            height: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            No Petition has been signed.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export const AccountTagged = () => {
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const { items, sentryRef, loading } =
    useInfiniteScrollFetcher<ReportContainerPropsType>({
      fetchData: apiGetRepTaggedPetitions,
      initialParams: { page: 1, page_size: 10, account_id: account_profile.id },
    });

  return (
    <Box>
      {items?.map((feed: ReportContainerPropsType, index: number) => (
        <Box key={index}>
          <ReportContainer
            key={index}
            id={feed?.id}
            link={feed?.id}
            content={feed?.context}
            account={feed?.author}
            title={feed?.title}
            source={feed?.post_type}
            badge={feed?.author_badge ?? 0}
            avatarImg={feed?.author_photo_url ?? ""}
            date={feed?.created_at}
            image={feed?.media}
            current_user_bookmarked={feed?.current_user_bookmarked ?? false}
            current_user_liked={feed?.current_user_liked ?? false}
            current_user_reposted={feed?.current_user_reposted ?? false}
            data={feed}
            social={{
              message: feed?.comments,
              repost: feed?.reposts,
              like: feed?.likes,
            }}
          />
          <Divider sx={{ my: 3 }} />
        </Box>
      ))}
      <div ref={sentryRef} style={{ width: "560px", margin: "0 auto" }}>
        {loading && (
          <Box sx={{}}>
            <SkeletonAccountPostLoading />
          </Box>
        )}
      </div>
      {!loading && items?.length === 0 && (
        <Box
          sx={{
            width: "80%",
            mx: "auto",
            height: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            No tagged petition has been found.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export const AccountPosts = () => {
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const { items, sentryRef, loading } =
    useInfiniteScrollFetcher<PostContentDetails>({
      fetchData: apiGetAccountPosts,
      initialParams: { page: 1, page_size: 10, account_id: account_profile.id },
    });

  return (
    <Box>
      {items?.map((post: any, index: number) => (
        <Box key={index}>
          <AccountReportContent post_details={post} />
          <Divider sx={{ my: 3 }} />
        </Box>
      ))}
      <div ref={sentryRef} style={{ width: "560px", margin: "0 auto" }}>
        {loading && (
          <Box sx={{}}>
            <SkeletonAccountPostLoading />
          </Box>
        )}
      </div>
      {!loading && items?.length === 0 && (
        <Box
          sx={{
            width: "80%",
            mx: "auto",
            height: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            No Posts has been made.
          </Typography>
        </Box>
      )}
    </Box>
  );
};
export const AccountBookmark = () => {
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const { items, sentryRef, loading } =
    useInfiniteScrollFetcher<ReportContainerPropsType>({
      fetchData: apiGetAccountBookmark,
      initialParams: { page: 1, page_size: 10, account_id: account_profile.id },
    });
console.log(items, "ITTM")
  return (
    <Box>
      {items?.map((feed: ReportContainerPropsType, index: number) => (
        <Box key={index}>
          <ReportContainer
            key={index}
            id={feed?.id}
            link={feed?.id}
            content={feed?.context}
            account={feed?.author}
            title={feed?.title}
            source={feed?.post_type}
            badge={feed?.author_account_type ?? 0}
            avatarImg={feed?.author_photo_url ?? ""}
            date={feed?.created_at}
            image={feed?.media}
            current_user_bookmarked={feed?.current_user_bookmarked ?? false}
            current_user_liked={feed?.current_user_liked ?? false}
            current_user_reposted={feed?.current_user_reposted ?? false}
            data={feed}
            social={{
              message: feed?.comments,
              repost: feed?.reposts,
              like: feed?.likes,
            }}
          />
          <Divider sx={{ my: 3 }} />
        </Box>
      ))}
      <div ref={sentryRef} style={{ width: "560px", margin: "0 auto" }}>
        {loading && (
          <Box sx={{}}>
            <SkeletonAccountPostLoading />
          </Box>
        )}
      </div>
      {!loading && items?.length === 0 && (
        <Box
          sx={{
            width: "80%",
            mx: "auto",
            height: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            No Post has been bookmarked
          </Typography>
        </Box>
      )}
    </Box>
  );
};
export const AccountReplies = () => {
  const navigate = useNavigate();
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const { items, sentryRef, loading } =
    useInfiniteScrollFetcher<ReplyDataProps>({
      fetchData: apiGetAccountReplies,
      initialParams: { page: 1, page_size: 10, account_id: account_profile.id },
    });
  return (
    <Box>
      {items?.map((reply: ReplyDataProps, index: number) => (
        <Box
          key={index}
          onClick={() =>
            navigate(PATH_DASHBOARD.post, {
              state: { postId: reply?.comment_id },
            })
          }
          sx={{
            cursor: "pointer",
          }}
        >
          <AccountComment key={reply.commented_entity.id} data={reply} />
        </Box>
      ))}
      <div ref={sentryRef} style={{ width: "560px", margin: "0 auto" }}>
        {loading && (
          <Box sx={{}}>
            <SkeletonAccountReplyLoading />
          </Box>
        )}
      </div>
      {!loading && items?.length === 0 && (
        <Box
          sx={{
            width: "80%",
            mx: "auto",
            height: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            No Reply has been made.
          </Typography>
        </Box>
      )}
    </Box>
  );
};
